import axios from "axios";
import { GET_FOTOR_BASE_URL, getGoArtXAppId } from "@Common";
import goartService from "./goartRequest";

// 创建axios实例, 自定义 base Url
const service = axios.create({
    baseURL: GET_FOTOR_BASE_URL()
});

/**
 * 注销 GoArt 账号
 * @param token token 
 * @returns 
 */
export function cancelAccount(token: string) {
    return service({
        url: "/goart/app/api/user/cancel-account",
        method: "get",
        headers: {
            "x-app-id": getGoArtXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 获取 GoArt 账号注销状态
 * @param token token 
 * @returns 
 */
export function getCancelStatus(token: string) {
    return service({
        url: "/goart/app/api/user/cancellation",
        method: "get",
        headers: {
            "x-app-id": getGoArtXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 撤销 GoArt 账号注销申请
 * @param token token
 * @returns 
 */
export function withdrawalDeleteAccount(token: string) {
    return service({
        url: "/goart/app/api/user/undo-cancel",
        method: "delete",
        headers: {
            "x-app-id": getGoArtXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}


/**
 * 获取GoArt用户VIP信息
 * @param token 
 * @returns 
 */
export function getGoArtUserVipInfo(token: string) {
    return service({
        url: "/pay/service/en/payment/goart/check/isvip",
        method: "get",
        headers: {
            // "x-app-id": getGoArtXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 获取GoArt用户积分信息
 * @param token 
 * @returns 
 */
export function getGoArtUserScoreInfo(token: string) {
    return service({
        url: "/api/create/goart/getScore",
        method: "get",
        headers: {
            "x-app-id": getGoArtXAppId(),
            Authorization: 'bearer ' + token
        },
    });
}

/**
 * 用户登录
 * @param data.email
 * @param data.password
 * @param data.platform 平台，1-安卓，2-苹果（默认）
 * @returns 
 */
export function goArtUserLogin(params:{
    email: string,
    password: string,
    platform: string, //平台，1-安卓，2-苹果（默认）
}) {
    let formData = new FormData()
    formData.append('email', params.email)
    formData.append('password', params.password)
    formData.append('platform', params.platform)
    return goartService({
        url: "/user/login",
        method: "post",
        data: formData,
    });
}